export default __webpack_public_path__ + "static/media/sweet-pain.f0ca232d.png";